<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="accountTypeSelected"
    :clearable="!unclearable"
    :items="accountTypeItems"
    :loading="accountTypeLoading"
    :label="noLabel ? '' : label ? label : $t('SubAccount.Fields.type')"
    :search-input.sync="accountTypeSearch"
    item-text="name"
    item-value="type"
    item-disabled="disabled"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :disabled="disabled"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import SubAccountSettings from "@/api/sub_account_settings";

export default {
  name: "SearcherSubAccountType",

  props: {
    value: Object,
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    label: String,
    disabled:Boolean
  },

  computed: {
    accountTypeItems() {
      return this.accountType.map((c) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == c.id)
          : false;
        return Object.assign({}, c, { disabled });
      });
    },
  },

  data: () => ({
    accountType: [],
    accountTypeLoading: false,
    accountTypeSearch: "",
    accountTypeSelected: null,
  }),
  mounted() {
    this.accountTypeLoading = true;
    SubAccountSettings.fetchAll()
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            var accountType = response.data.sub_account_settings;
            var Items = [];
             for (let key in accountType) {
              Items.push(
                Object.assign({}, accountType[key], {
                  type: key,
                })
              );
            }
            this.accountType = Items;
          }
          this.accountTypeLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.accountTypeLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.accountTypeSelected = this.value;
      },
    },
    accountTypeSelected: {
      handler() {
        this.$emit("input", this.accountTypeSelected);
      },
    },
  },
};
</script>